import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { Box } from '../Box/Box.js';
import styled from 'styled-components';

var GroupStyled = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Groupstyled__GroupStyled",
  componentId: "sc-1fm9tas-0"
})(function (props) {
  var _ref;
  var isRTL = props.$isRTL;
  var borderRadius = props.$radius;
  var childGroupClassName = '.child-group';
  var firstChildStyle = {
    borderTopLeftRadius: isRTL ? borderRadius : undefined,
    borderBottomLeftRadius: isRTL ? borderRadius : undefined,
    borderTopRightRadius: isRTL ? undefined : borderRadius,
    borderBottomRightRadius: isRTL ? undefined : borderRadius
  };
  var middleStyle = {
    borderRadius: borderRadius
  };
  var lastChildStyle = {
    borderTopLeftRadius: isRTL ? undefined : borderRadius,
    borderBottomLeftRadius: isRTL ? undefined : borderRadius,
    borderTopRightRadius: isRTL ? borderRadius : undefined,
    borderBottomRightRadius: isRTL ? borderRadius : undefined
  };
  return _ref = {
    display: 'inline-flex',
    '> *': {
      borderWidth: '0',
      borderStyle: 'none',
      boxShadow: 'none'
    }
  }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "> ".concat(childGroupClassName, ":first-child"), firstChildStyle), "> *:first-child > ".concat(childGroupClassName), firstChildStyle), "> *:first-child > * > ".concat(childGroupClassName), firstChildStyle), "> *:first-child > * > * > ".concat(childGroupClassName), firstChildStyle), "> ".concat(childGroupClassName, ":not(:first-child):not(:last-child)"), middleStyle), "> *:not(:first-child):not(:last-child) > ".concat(childGroupClassName), middleStyle), "> *:not(:first-child):not(:last-child) > * > ".concat(childGroupClassName), middleStyle), "> *:not(:first-child):not(:last-child) > * > * > ".concat(childGroupClassName), middleStyle), "> ".concat(childGroupClassName, ":last-child"), lastChildStyle), "> *:last-child > ".concat(childGroupClassName), lastChildStyle), _defineProperty(_defineProperty(_ref, "> *:last-child > * > ".concat(childGroupClassName), lastChildStyle), "> *:last-child > * > * > ".concat(childGroupClassName), lastChildStyle);
});

export { GroupStyled };
//# sourceMappingURL=Group.styled.js.map
